import config, { SERVER_ENV_ENUM } from '@root/src/config';
import { NextRequest } from 'next/server';
import { destroyCookie, parseCookies, setCookie } from 'nookies';

const DAY = 60 * 60 * 24;
export const AUTH_COOKIE_NAME = 'api_backend_token';

export const setAuthCookie = (token: string): void => {
  setCookie(null, AUTH_COOKIE_NAME, token, {
    maxAge: DAY * 120,
    path: '/',
    sameSite: config.environment === SERVER_ENV_ENUM.dev || SERVER_ENV_ENUM.local ? 'none' : 'lax',
    secure: true,
  });
};

export const destroyAuthCookie = (): void => {
  destroyCookie(null, AUTH_COOKIE_NAME, { path: '/' });
};
export const getAuthCookies: (request: NextRequest) => {
  token: string | null;
} = request => {
  if (request.cookies) {
    const cookies = request.cookies.get(AUTH_COOKIE_NAME);
    if (cookies) {
      return { token: cookies.value };
    }
  }
  return { token: null };
};

export const isAuthenticatedWithoutRequest = (): boolean => parseCookies(null)[AUTH_COOKIE_NAME] !== undefined;
